"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _commonComponent = require("../../propTypes/commonComponent");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _formValidations = require("../../helpers/formValidations");
var _passwordScore = _interopRequireDefault(require("../../helpers/passwordScore"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _StandAloneLayout = _interopRequireDefault(require("../../layouts/StandAloneLayout/StandAloneLayout"));
require("../../styles/components/common/StandaloneForm.css");
require("./ResetPasswordFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-form');
var resetPasswordClasses = (0, _cssClassesHelper.getBEMClasses)('reset-password');
var ResetPasswordFormComponent = /*#__PURE__*/function (_React$Component) {
  function ResetPasswordFormComponent() {
    var _this;
    _classCallCheck(this, ResetPasswordFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResetPasswordFormComponent, [].concat(args));
    _defineProperty(_this, "handleChange", function () {
      if (_this.props.validateError) {
        _this.props.clearResetPasswordError();
      }
    });
    _defineProperty(_this, "getPasswordStrength", function () {
      var t = _this.props.t;
      var score = (0, _passwordScore["default"])(_this.props.passwordValue);
      var passwordStrengthValues = {
        0: t('Very Weak'),
        1: t('Weak'),
        2: t('Medium'),
        3: t('Strong'),
        4: t('Very Strong')
      };
      return passwordStrengthValues[score];
    });
    return _this;
  }
  _inherits(ResetPasswordFormComponent, _React$Component);
  return _createClass(ResetPasswordFormComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        processingResetPassword = _this$props.processingResetPassword,
        message = _this$props.message,
        handleSubmit = _this$props.handleSubmit,
        fetchError = _this$props.fetchError,
        pristine = _this$props.pristine,
        passwordValue = _this$props.passwordValue,
        invalid = _this$props.invalid,
        success = _this$props.success;
      return /*#__PURE__*/_react["default"].createElement(_StandAloneLayout["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('container'), " ").concat(resetPasswordClasses('container'))
      }, !message && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('header'), " ").concat(resetPasswordClasses('header'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('header-text'))
      }, t('Reset Your Password')), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: (0, _path["default"])('/'),
        className: baseClasses('close-icon')
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "close",
        classModifiers: "big"
      }))), !success && /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        className: "".concat(baseClasses('form'))
      }, /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        type: "password",
        name: "password",
        customClass: resetPasswordClasses(),
        label: t('New Password'),
        validate: [_formValidations.required],
        readOnly: processingResetPassword,
        info: passwordValue && /*#__PURE__*/_react["default"].createElement("span", {
          className: baseClasses('password-strength')
        }, this.getPasswordStrength()),
        onChange: this.handleChange
      }), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        type: "password",
        name: "matchingPassword",
        customClass: resetPasswordClasses(),
        label: t('Repeat New Password'),
        readOnly: processingResetPassword,
        validate: [_formValidations.required],
        onChange: this.handleChange
      }), message && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('password-error')
      }, t(message)), /*#__PURE__*/_react["default"].createElement("hr", {
        className: "".concat(resetPasswordClasses('separator'))
      }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        disabled: pristine || processingResetPassword || invalid,
        customClass: "".concat(resetPasswordClasses()),
        styleName: _commonComponent.styleNames.additive
      }, processingResetPassword ? t('Resetting your password...') : t('Reset Password'))), success && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('message'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('message-text'))
      }, t(message))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('message-footer'))
      }, fetchError ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: (0, _path["default"])('/problem-logging-in'),
        className: baseClasses('btn', 'subtractive')
      }, t('Problem resetting your password?')) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: (0, _path["default"])('/login'),
        className: baseClasses('btn', 'additive')
      }, t('Go to Exchange'))))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ResetPasswordFormComponent, "defaultProps", {
  handleSubmit: function handleSubmit() {},
  processingResetPassword: false,
  message: '',
  fetchError: false
});
_defineProperty(ResetPasswordFormComponent, "propTypes", {
  handleSubmit: _propTypes["default"].func.isRequired,
  processingResetPassword: _propTypes["default"].bool.isRequired,
  fetchError: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)('auth')(ResetPasswordFormComponent);